import { useBulkPersonalOrderSessionStore } from '../../../store/bulkPersonalOrderSessionStore'

export const bulkOrderAgreementChecker = () => {
  const store = useBulkPersonalOrderSessionStore()
  if (!store.isAgreementBulkOrder) {
    window.location.href = '/bulk_order/gift_cards'
  }
}
